var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8178 8.50249L10.7318 13.477L10.4455 13.7116C10.3826 13.7615 10.3415 13.8338 10.3309 13.9134L10.2668 14.4425L10.0909 15.9289C10.0926 15.9469 10.0869 15.9649 10.0753 15.9789C10.0637 15.9928 10.047 16.0015 10.0289 16.0032C10.0108 16.0048 9.99281 15.9992 9.97888 15.9875C9.96494 15.9759 9.9562 15.9592 9.95457 15.9411L9.45957 14.4548L8.9482 12.9343C8.92639 12.8662 8.92918 12.7925 8.95609 12.7263C8.98301 12.66 9.03234 12.6052 9.09548 12.5716L15.4282 8.94158L16.62 8.25976C16.7932 8.15886 16.9705 8.37704 16.8178 8.50249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 0H3.27273C2.40475 0 1.57232 0.344804 0.95856 0.95856C0.344804 1.57232 0 2.40475 0 3.27273L0 20.7273C0 21.5953 0.344804 22.4277 0.95856 23.0414C1.57232 23.6552 2.40475 24 3.27273 24H20.7273C21.5953 24 22.4277 23.6552 23.0414 23.0414C23.6552 22.4277 24 21.5953 24 20.7273V3.27273C24 2.40475 23.6552 1.57232 23.0414 0.95856C22.4277 0.344804 21.5953 0 20.7273 0ZM19.485 6.94636L17.1423 17.2977C17.0318 17.7832 16.4155 18.0027 15.9832 17.7068L12.4459 15.3068L10.6445 17.01C10.5711 17.0789 10.4819 17.1289 10.3848 17.1555C10.2877 17.1822 10.1855 17.1848 10.0871 17.163C9.9888 17.1412 9.89725 17.0958 9.82044 17.0306C9.74363 16.9655 9.68387 16.8826 9.64636 16.7891L8.99591 14.88L8.34546 12.9709L4.85864 12.0164C4.76115 11.9951 4.67342 11.9422 4.60909 11.8659C4.54477 11.7896 4.50745 11.6942 4.50294 11.5945C4.49843 11.4948 4.52698 11.3964 4.58415 11.3147C4.64133 11.2329 4.72392 11.1723 4.81909 11.1423L18.2891 6.28909L18.5373 6.20045C19.0595 6.01773 19.5995 6.44045 19.485 6.94636Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.be7b8ed11789728b935150a7080c2517.svg";
export { ForwardRef as ReactComponent };